export default __webpack_public_path__ + "static/media/School_Cold_3_2.dc5e0c5c.png";